import { buildDashboardPathUrl } from 'utils/dashboard';
import type { StepItem, Translate } from './types';

export const WIX_HOME_URL = 'https://www.wix.com';
export const FALLBACK_CUSTOM_DOMAIN = 'acme-fashion.com';
export const CONNECT_DOMAIN_VIDEO_EMBED_URL = 'https://www.youtube.com/embed/FffnSKtPHDM?rel=0';
export const SETUP_VIDEO_EMBED_URL = 'https://www.youtube.com/embed/slZ7DXu1QK4?rel=0';
export const SETUP_VIDEO_DASHBOARD_PATH = 'settings/payments';

export function getPostPurchaseSteps(t: Translate): StepItem[] {
  return [
    {
      id: 'storefront',
      number: 1,
      title: t('post_purchase.steps.storefront.title'),
      description: t('post_purchase.steps.storefront.description'),
      cta: t('post_purchase.cta.done'),
      done: true,
    },
    {
      id: 'setup',
      number: 2,
      title: t('post_purchase.steps.setup.title'),
      description: t('post_purchase.steps.setup.description'),
      cta: t('post_purchase.cta.go'),
    },
    {
      id: 'domain',
      number: 3,
      title: t('post_purchase.steps.domain.title'),
      description: t('post_purchase.steps.domain.description'),
      cta: t('post_purchase.cta.lets_go'),
    },
  ];
}

function getDomainFromUrl(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return url
      .replace(/^https?:\/\//, '')
      .split('/')[0]
      .replace(/^www\./, '');
  }
}

function toDomainSlug(value: string): string {
  return value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function getSuggestedDomain(siteUrl: string | undefined, storeName?: string | null): string {
  // Prefer the store name for the prefilled domain when we have it.
  const storeNameSlug = storeName ? toDomainSlug(storeName) : '';
  if (storeNameSlug) {
    return `${storeNameSlug}.com`;
  }

  if (!siteUrl) {
    return FALLBACK_CUSTOM_DOMAIN;
  }

  try {
    const url = new URL(siteUrl);
    const sourceDomain = getDomainFromUrl(siteUrl);

    if (sourceDomain.includes('wixsite.com')) {
      const pathSlug = url.pathname.split('/').filter(Boolean).pop();
      const accountSlug = sourceDomain.split('.')[0];
      const slug = toDomainSlug(pathSlug || accountSlug || '');
      return slug ? `${slug}.com` : FALLBACK_CUSTOM_DOMAIN;
    }

    return sourceDomain || FALLBACK_CUSTOM_DOMAIN;
  } catch {
    return FALLBACK_CUSTOM_DOMAIN;
  }
}

export function getDisplayUrl(url: string): string {
  return url.replace(/^https?:\/\//, '').replace(/\/$/, '');
}

export function buildDashboardActionUrl(metaSiteId: string | null, path: string): string | undefined {
  return metaSiteId ? buildDashboardPathUrl(metaSiteId, path) : undefined;
}

export function hasPostPurchaseAccess(
  metaSiteId: string | null,
  siteUrl: string | undefined,
  isSiteUrlError: boolean,
  isSiteUrlFetched: boolean,
): boolean {
  if (!metaSiteId) {
    return false;
  }

  if (isSiteUrlError) {
    return false;
  }

  return !isSiteUrlFetched || Boolean(siteUrl);
}
